import { Box } from '@mui/material';
import React from 'react';

type Props = { 
  fieldobject: any; 
  label: any;
  value: any; 
  error?: string; 
  readonly?: boolean; 
  slotOptions?: any,
  //extraOptions?: any,
  onChange: (value: any) => void; 
  [name:string]: any;
};

export class EditablePageField extends React.Component<Props, any> {

  render(){
    const {label,fieldobject,value,error,readonly,slotOptions={},onChange,...extraOptions} = this.props;

    if(!fieldobject) return <Box>{`Invalid ${label} Field`}</Box>;
    const {fieldid,fieldcomponent,fieldprops={}} = fieldobject;
    const finalprops = {
      ...fieldprops,
      label,
      value,
      error:Boolean(error),
      slotProps:{ 
        ...slotOptions,
        htmlInput: { readOnly: readonly } 
      }, 
      onChange,
      ...(extraOptions||{}),
    };

    const Field = (React.cloneElement(fieldcomponent,finalprops));

    return Field;
  }
}

export default EditablePageField;
